import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {DasUBoot} from "../DasUBoot";
import {DasUBootSound} from "../sound/DasUBootSound";
import {SymbolUtils} from "../utils/SymbolUtils";
import {DasUBootSymbolStates} from "../reels/DasUBootSymbol";
import {DasUBootStatics} from "../utils/DasUBootStatics";
import {DasUBootGameMode} from "../server/DasUBootGameMode";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class DasUBootNormalBetPresentation implements FlowStatePresentation {

    constructor() {

    }



    public start(flowStateController:FlowStateController) {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => flowStateController.finish()});
        const delay = DasUBootStatics.stepDuration;

        for (let reel of DasUBoot.reelView.reels){
            reel.changeReelSet(DasUBoot.model.data.roundType);
        }

        tl.add(() => {
            DasUBoot.reelView.reelFrame.switchLampOnReel(1,-1);
            DasUBoot.reelView.reelFrame.switchLampOnReel(2,-1);
            DasUBoot.reelView.reelFrame.switchLampOnReel(3,-1);
            DasUBoot.reelView.reelFrame.switchLampOnReel(4,-1);
        });


        if (DasUBoot.model.data.nextMode == DasUBootGameMode.NORMAL){
            tl.add(()=> {DasUBoot.reelView.reelFrame.xBombMultiplierDisplay.setMultiplier(0)});
        }

        tl.add(() => {DasUBoot.reelView.reelFrame.possibleWinWaysDisplay.setWinWays(DasUBoot.model.possibleWinWays[0])});
        tl.add(SymbolUtils.getSymbolStateAnimations(DasUBoot.reelView.getAllVisibleSymbols(), DasUBootSymbolStates.START_SPIN));
        tl.add(() => DasUBoot.soundPlayer.playSound(DasUBootSound.REELS_SPINNING, 1,-1));

        const reelStart = gsap.timeline();
        reelStart.add(DasUBoot.reelView.reelModels[0].start(false), delay * 2);
        reelStart.add(DasUBoot.reelView.reelModels[1].start(false), delay * 1);
        reelStart.add(DasUBoot.reelView.reelModels[2].start(false), delay * 0);
        reelStart.add(DasUBoot.reelView.reelModels[3].start(false), delay * 0);
        reelStart.add(DasUBoot.reelView.reelModels[4].start(false), delay * 1);
        reelStart.add(DasUBoot.reelView.reelModels[5].start(false), delay * 2);

        tl.add(reelStart);

    }
}